<template>
  <div class="right">
    <div class="top" ref="top">
      <span>已选择({{ list.length }}/1000)</span>
      <span @click="deleteAll"><i class="el-icon-delete"></i>清空</span>
    </div>
    <div class="list" :style="{ height: listHeight }">
      <dsf-virtual-scroll scroll-x>
        <result-li
          v-for="(li, i) in list"
          :key="li.id"
          :li="li"
          :index="i"
        ></result-li>
      </dsf-virtual-scroll>
    </div>
  </div>
</template>

<script>
import resultLi from "./resultLi.vue";
export default {
  name: "resultList",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components:{
    resultLi
  },
  inject: {
    $seletPermissions: {
      default: null,
    },
  },
  data() {
    return {
      listHeight: 0,
    };
  },
  mounted() {
    this.getListHeight();
    window.onresize = this.resize;
  },
  methods: {
    resize() {
      this.getListHeight();
    },
    getListHeight() {
      this.listHeight = `calc(100% - ${this.$refs.top.clientHeight}px)`;
    },
    deleteAll() {
      _.forEachRight(this.list, (li, i) => {
        li.config_includeChild = false;
        li.config_checked = false;
      });
      this.$seletPermissions.resultLists = [];
      this.$seletPermissions.defaultSelectValue = [];
    },
  },
};
</script>
